import React from 'react';
import { AsteriskIcon } from '@tanium/react-graphics';
import { useTheme } from '@tanium/react-theme-context';
import { RequiredAsterisk } from './themeDefinitions';

export const RequiredStar = () => {
  const theme = useTheme();

  return <AsteriskIcon width={8} height={8} color={RequiredAsterisk(theme)} />;
};
